import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ConfirmPopup, confirmPopup } from "primereact/confirmpopup";
import { InputNumber } from "primereact/inputnumber";
import { Checkbox } from "primereact/checkbox";
import api from "../../api/axios";
import { useAuth } from "../../context/AuthContext";
import SupplierService from "../../services/SupplierService";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import { useNavigate, useBlocker } from "react-router-dom";
import { AutoComplete } from "primereact/autocomplete";
import { Skeleton } from "primereact/skeleton";
import WarehouseService from "../../services/WarehouseService";
import FinancialAccountService from "../../services/FinancialAccountService";

const filterItems = (arr = [], query = "") =>
  arr.filter(item => (item.label || "").toLowerCase().includes((query || "").toLowerCase()));

const enrichCategories = (list = [], query = "") => {
  if (!query) return list;

  const exists = list.some(c => (c.label || "").toLowerCase() === query.toLowerCase());
  if (exists) return list;

  return [
    ...list,
    { label: `"${query}" adlı yeni kategori ekle`, value: "__create__", rawName: query, isCreate: true }
  ];
};

export default function SupplierPurchaseCreatePage() {
  const navigate = useNavigate();
  const { id: editId } = useParams();
  const toast = useRef(null);
  const [isDirty, setIsDirty] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(true);
const [mounted, setMounted] = useState(false);
 useEffect(() => {
    setMounted(true);
  }, []);

  // Minimal supplier info (dummy) — will be replaced if route state provides supplierId
  const [supplier, setSupplier] = useState({
    id: 0,
    name: "",
    balance: 0,
    useDueTracking: false,
    defaultDueDay: 0
  });
  const [warehouseOptions, setWarehouseOptions] = useState([]);

  /* ---------------------------------------------------
    PRODUCT AUTOCOMPLETE (BACKEND)
 --------------------------------------------------- */

  const [productQuery, setProductQuery] = useState("");
  const [products, setProducts] = useState([]);
  const [showList, setShowList] = useState(false);
  const [highlightIndex, setHighlightIndex] = useState(0);
  const overlayRef = useRef(null);
  const inputRef = useRef(null);
  const quantityRef = useRef(null);
  const priceRef = useRef(null);
  const totalPriceRef = useRef(null);
  const discountRef = useRef(null);
  const vatRef = useRef(null);
  const batchNoRef = useRef(null);
  const expirationDateRef = useRef(null);
  // Yeni satır giriş alanı
  const [newLine, setNewLine] = useState({
    product: null,
    quantity: 1,
    unitPrice: null,
    unitPriceIsVatIncluded: false,
    addToStock: true,
    discountRate: 0,
    vatRate: 0,
    batchNo: "",
    expirationDate: null,
  });
  const [createProductModal, setCreateProductModal] = useState({
    visible: false,
    productName: "",
    barcode: "",
    unitTypeId: 1, // default: Adet
    category: null, // {label, value}
    salePrice: null,
    salePriceIsVatIncluded: false,
    taxRate: 0,
  });
  const [lines, setLines] = useState([]);
 const [unitTypes, setUnitTypes] = useState([]); // [{label, value}]
const [productCategories, setProductCategories] = useState([]); // [{label, value}]
const [filteredProductCategories, setFilteredProductCategories] = useState([]);
  const [modalErrors, setModalErrors] = useState({});
  const [isUnitTypeOpen, setIsUnitTypeOpen] = useState(false);
   const [isAddFocused, setIsAddFocused] = useState(false);
 
  // row edit için geçici klonlar
  const [clonedRows, setClonedRows] = useState({});
  // Evrak / header form (DTO uyumlu alan adları)
  const [purchaseHeader, setPurchaseHeader] = useState({
    invoiceNo: "FTR"+"-"+Math.floor(Math.random()*100000),
    purchaseDate: new Date(),
    dueDate: null,
    warehouseId: null,
    warehouseCode: "MERKEZ",
    currencyCode: "TRY",
    paymentType: 4, // 4:Vadeli (Açık Hesap)
    description: "",
    financialAccountId: null,
    existingPayments: []
  });

  const [financialAccounts, setFinancialAccounts] = useState([]);

  const location = useLocation();

  const { user: authUser } = useAuth();

  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      isDirty && !isSubmitting && currentLocation.pathname !== nextLocation.pathname
  );

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (isDirty && !isSubmitting) {
        e.preventDefault();
        e.returnValue = "";
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [isDirty, isSubmitting]);

  useEffect(() => {
    FinancialAccountService.getAll().then(res => {
      if (res.success) {
        setFinancialAccounts(res.data || []);
      }
    });
  }, []);

  useEffect(() => {
    if (editId) {
      setLoading(true);
      // Fetch existing transaction data
      SupplierService.getPurchaseTransactionDetail(editId).then(res => {
        if (res.success) {
          const data = res.data;
          setSupplier({
            id: data.supplierId,
            name: data.supplierName,
            balance: 0
          });
          // Fetch actual balance
          SupplierService.getSupplierById(data.supplierId).then(sres => {
            if (sres) {
               setSupplier(prev => ({
                 ...prev,
                 balance: sres.balance,
                 useDueTracking: sres.useDueTracking,
                 defaultDueDay: sres.defaultDueDay
               }));
            }
          }).finally(() => setLoading(false));
          setPurchaseHeader({
            invoiceNo: data.invoiceNo,
            purchaseDate: new Date(data.purchaseDate),
            dueDate: data.dueDate ? new Date(data.dueDate) : null,
            warehouseCode: data.warehouseCode,
            currencyCode: data.currencyCode,
            paymentType: (data.paymentType === 4 && data.dueDate) ? 5 : data.paymentType,
            description: data.description,
            existingPayments: data.payments || []
          });
          setLines(data.lines.map((l, idx) => ({
            id: `line-${idx}-${Date.now()}-${Math.floor(Math.random() * 1000)}`,
            productId: l.productId,
            productName: "Yükleniyor...", // Will be updated if we fetch product names or if backend provides them
            unit: l.unit,
            quantity: l.quantity,
            unitPrice: l.unitPrice,
            unitPriceIsVatIncluded: l.unitPriceIsVatIncluded,
            addToStock: l.addToStock,
            discountRate: l.discountRate,
            vatRate: l.vatRate,
            batchNo: l.batchNo,
            expirationDate: l.expirationDate ? new Date(l.expirationDate) : null,
          })));

          // Enrich lines with product names (ideally backend should provide them)
          data.lines.forEach((l, idx) => {
             api.get(`/product/get-product/${l.productId}`).then(pres => {
                setLines(prev => prev.map((line, i) => i === idx ? {...line, productName: pres.data.data.name} : line));
             });
          });
        } else {
          setLoading(false);
        }
      }).catch(() => setLoading(false));
      return;
    }

    const sid = location?.state?.supplierId;
    const sname = location?.state?.supplierName;
    const cid = location?.state?.customerId;
    const cname = location?.state?.customerName;
    if (!sid && !sname && !cid && !cname) {
      setLoading(false);
      return;
    }

    setSupplier((prev) => ({
      id: sid ?? (cid ? 0 : prev.id),
      name: sname ?? (cname ?? prev.name),
      customerId: cid ?? prev.customerId,
      balance: prev.balance,
    }));

    if (sid) {
      setLoading(true);
      SupplierService.getSupplierById(sid).then(sres => {
        if (sres) {
          setSupplier(prev => ({
            ...prev,
            balance: sres.balance,
            useDueTracking: sres.useDueTracking,
            defaultDueDay: sres.defaultDueDay
          }));
        }
      }).finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [location?.state, editId]);

  // Backend enum int olacak şekilde
  const paymentTypeOptions = useMemo(() => {
    const options = [
      { label: "Nakit", value: 1 },
      { label: "Banka Havalesi", value: 2 },
      { label: "Kredi Kartı", value: 3 },
      { label: "Açık Hesap", value: 4 },
    ];

    if (supplier.useDueTracking || location?.state?.fromCustomerDetail) {
      options.push({ label: "Vade Tarihli Takip", value: 5 }); // 5 will be mapped to 4 in backend but tells us to use DueDate logic
    }

    return options;
  }, [supplier.useDueTracking, location?.state?.fromCustomerDetail]);

  useEffect(() => {
    if (purchaseHeader.paymentType === 5) {
      const d = new Date(purchaseHeader.purchaseDate);
      d.setDate(d.getDate() + (supplier.defaultDueDay || 0));
      setPurchaseHeader(prev => ({ ...prev, dueDate: d }));
    } else {
      setPurchaseHeader(prev => ({ ...prev, dueDate: null }));
    }
  }, [purchaseHeader.paymentType, supplier.defaultDueDay, purchaseHeader.purchaseDate]);

 
  useEffect(() => {
    setHighlightIndex(0);
  }, [products]);

  useEffect(() => {
    setTimeout(() => {
      inputRef.current?.focus();
    }, 0);
  }, []);

  useEffect(() => {
    if (!newLine.product) {
      inputRef.current?.focus();
    }
  }, [newLine.product]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key !== "Escape") return;

      e.preventDefault();

      // ✅ 1) Eğer ürün seçiliyse → onu iptal et
      if (newLine.product) {
        setProductQuery(newLine.product.name); // ürünü inputa geri yaz
        setNewLine((prev) => ({
          ...prev,
          product: null,
        }));
      }
      // ✅ 2) Sadece arama yapıyorsa → inputu temizle
      else {
        setProductQuery("");
      }

      setProducts([]);
      setHighlightIndex(0);
      overlayRef.current?.hide();

      // fokus garanti
      setTimeout(() => {
        inputRef.current?.focus();
      }, 0);
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [newLine.product]);

  // Helper for InputNumber focus/select
  const focusAndSelect = (ref) => {
    if (!ref.current) return;
    // PrimeReact InputNumber exposes input element via .getInput() or different depending on version
    // Or we focus the component wrapper. 
    // Best effort:
    const inputEl = ref.current.getInput ? ref.current.getInput() : ref.current.input?.current || ref.current.input;

    if (inputEl && inputEl.select) {
      inputEl.focus();
      inputEl.select();
    } else {
      // Fallback
      ref.current.focus?.();
    }
  };

  const selectProduct = (product) => {
    if (!product) return;
 
    setNewLine((prev) => ({
      ...prev,
      product,
      unitPrice: product.defaultPurchasePrice ?? 0,
      vatRate: (product.vatRate === 0 || product.vatRate === null || product.vatRate === undefined) ? 0 : product.vatRate,
      unit: product.unit || "",
      quantity: 1,
      unitPriceIsVatIncluded: product.isVatIncluded || false,
    }));

    setProductQuery(product.name ?? "");
    setProducts([]);
    setShowList(false);

    // Focus quantity input after selection
    setTimeout(() => {
      focusAndSelect(quantityRef);
    }, 400);
  };

  const enrichProducts = (list, query) => {
    if (!query) return list;

    const exists = list.some(
      (p) => p.name.toLowerCase() === query.toLowerCase()
    );

    if (!exists) {
      return [
        ...list,
        {
          id: "__create__",
          name: `"${query}" adlı yeni ürün ekle`,
          isCreate: true,
          rawName: query,
        },
      ];
    }

    return list;
  };

  const searchProducts = async (query, event) => {
    if (!inputRef.current) return;

    try {
      const res = await api.get("/product/autocomplete", {
        params: { query, take: 20 },
      });
      const list = enrichProducts(res.data || [], query);
      setProducts(list);
      setShowList(true);
      setHighlightIndex(0);
    } catch (e) {
      setProducts([]);
    }

  };

  const handleNewLineChange = (field, value) => {
    setNewLine((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  /* ---------------------------------------------------
     LINES
  --------------------------------------------------- */
 
  const saveProductBtnRef = useRef(null);
 
  const onRowEditInit = (event) => {
    setClonedRows((prev) => ({ ...prev, [event.data.id]: { ...event.data } }));
  };
  const onRowEditSave = (event) => {
    const updated = event.newData;
    setIsDirty(true);
    setLines((prev) => prev.map((r) => (r.id === updated.id ? updated : r)));
    setClonedRows((prev) => {
      const next = { ...prev };
      delete next[event.data.id];
      return next;
    });
  };
  const onRowEditCancel = (event) => {
    setLines((prev) =>
      prev.map((r) => (r.id === event.data.id ? clonedRows[event.data.id] : r))
    );
    setClonedRows((prev) => {
      const next = { ...prev };
      delete next[event.data.id];
      return next;
    });
  };
  const handleAddLine = () => {
    if (!newLine.product) return;

    const actualVatRate = newLine.vatRate ?? 0;

    setIsDirty(true);
    setLines((prev) => [
      ...prev,
      {
        id: Date.now(),
        productId: newLine.product.id,
        productName: newLine.product.name,
        unit: newLine.unit || "",
        quantity: newLine.quantity,
        unitPrice: newLine.unitPrice,
        unitPriceIsVatIncluded: newLine.unitPriceIsVatIncluded,
        addToStock: newLine.addToStock,
        discountRate: newLine.discountRate,
        vatRate: actualVatRate,
        batchNo: newLine.batchNo,
        expirationDate: newLine.expirationDate,
      },
    ]);

    // reset newLine fields for next entry (product cleared, price and KDV zeroed)
    setNewLine({
      product: null,
      quantity: 1,
      unitPrice: 0,
      unitPriceIsVatIncluded: false,
      addToStock: true,
      discountRate: 0,
      vatRate: 0,
      unit: "",
      batchNo: "",
      expirationDate: null,
    });
    // overlay'i kapat ama listeyi öldürme
    setProductQuery("");
    setShowList(false);
    setProducts([]);
    setIsAddFocused(false);
    // fokus garanti
    setTimeout(() => {
      inputRef.current?.focus();
    }, 0);
  };

  // change quantity by delta (±1)
  const changeLineQuantity = (id, delta) => {
    setIsDirty(true);
    setLines((prev) =>
      prev.map((l) =>
        l.id === id
          ? { ...l, quantity: Math.max(1, (Number(l.quantity) || 0) + delta) }
          : l
      )
    );
  };

  // use PrimeReact ConfirmPopup for small inline confirmation
  const openDeleteConfirm = (event, id) => {
    confirmPopup({
      target: event.currentTarget,
      message: "Bu satırı silmek istediğinize emin misiniz?",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sil",
      rejectLabel: "İptal",
      acceptClassName: "p-button-danger",
      accept: () => {
        setIsDirty(true);
        setLines((prev) => prev.filter((x) => x.id !== id));
      },
    });
  };

  /* ---------------------------------------------------
    TOTALS (UI)
 --------------------------------------------------- */
const totals = useMemo(() => {
  let gross = 0;
  let discountTotal = 0;
  let vatTotal = 0;
  let totalQuantity = 0;
  let grandTotal = 0;
  let paidTotal = 0;

  const round6 = (v) => Math.round((v + Number.EPSILON) * 1000000) / 1000000;
  const round4 = (v) => Math.round((v + Number.EPSILON) * 10000) / 10000;
  const round2 = (v) => Math.round((v + Number.EPSILON) * 100) / 100;

  purchaseHeader.existingPayments?.forEach(p => {
    paidTotal += Math.abs(p.amount);
  });

  lines.forEach((l) => {
    const qty = l.quantity || 0;
    const unitPrice = l.unitPrice || 0;
    const vatRate = l.vatRate || 0;
    const discountRate = l.discountRate || 0;

    if (l.unitPriceIsVatIncluded) {
      const unitPriceExcl =
        vatRate > 0 ? round6(unitPrice / (1 + vatRate / 100)) : unitPrice;

      const lineGrossExcl = round6(unitPriceExcl * qty);
      const discountExcl = round6(lineGrossExcl * (discountRate / 100));
      const netExclAfterDiscount = round6(lineGrossExcl - discountExcl);
      const vat = round6(netExclAfterDiscount * (vatRate / 100));
      const lineTotalIncl = round6(netExclAfterDiscount + vat);

      gross += lineGrossExcl;
      discountTotal += discountExcl;
      vatTotal += vat;
      grandTotal += lineTotalIncl;
      totalQuantity += qty;
    } else {
      const lineGrossExcl = round6(unitPrice * qty);
      const discountExcl = round6(lineGrossExcl * (discountRate / 100));
      const netExclAfterDiscount = round6(lineGrossExcl - discountExcl);
      const vat = round6(netExclAfterDiscount * (vatRate / 100));
      const lineTotalIncl = round6(netExclAfterDiscount + vat);

      gross += lineGrossExcl;
      discountTotal += discountExcl;
      vatTotal += vat;
      grandTotal += lineTotalIncl;
      totalQuantity += qty;
    }
  });

  return {
    gross: round4(gross),
    discountTotal: round4(discountTotal),
    vatTotal: round4(vatTotal),
    netTotal: round2(grandTotal),
    lineCount: lines.length,
    totalQuantity: round4(totalQuantity),
    paidTotal: round2(paidTotal),
    remainingTotal: round2(Math.max(0, grandTotal - paidTotal))
  };
}, [lines, purchaseHeader.existingPayments]);

  const handleHeaderChange = (field, value) => {
    setIsDirty(true);
    setPurchaseHeader((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const lineTotalTemplate = (rowData) => {
    const qty = rowData.quantity || 0;
    const unitPrice = rowData.unitPrice || 0;
    const discountRate = rowData.discountRate || 0;
    const vatRate = rowData.vatRate || 0;
    if (rowData.unitPriceIsVatIncluded) {
      const round2 = (v) => Math.round((v + Number.EPSILON) * 100) / 100;
      // KDV dahil birim fiyattan önce KDV'siz birim fiyat bulunur,
      // sonra iskontoyu KDV'siz fiyata uygula, en son KDV ekle.
      const unitPriceExcl = vatRate > 0 ? unitPrice / (1 + vatRate / 100) : unitPrice;
      const grossExcl = unitPriceExcl * qty;
      const discountExcl = round2(grossExcl * (discountRate / 100));
      const netExclAfterDiscount = round2(grossExcl - discountExcl);
      const vat = round2(netExclAfterDiscount * (vatRate / 100));
      const total = round2(netExclAfterDiscount + vat);

      return (
        <span className="font-medium">
          {total.toLocaleString("tr-TR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}{" "}
          ₺
        </span>
      );
    } else {
      const gross = qty * unitPrice;
      const discount = gross * (discountRate / 100);
      const net = gross - discount;
      const vat = net * (vatRate / 100);
      const total = net + vat;

      return (
        <span className="font-medium">
          {total.toLocaleString("tr-TR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}{" "}
          ₺
        </span>
      );
    }
  };
const formatDateOnly = (date) => {
  if (!date) return null;

  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

  // ✅ Backend DTO payload oluştur
  const buildDtoPayload = () => ({
    id: editId ? Number(editId) : null,
    tenantId: authUser?.tenantId ?? 0,
    createdUserId: authUser?.id ?? 0,
    supplierId: supplier.id === 0 ? null : (supplier.id || null),
    customerId: supplier.customerId || null,
    invoiceNo: purchaseHeader.invoiceNo,
    purchaseDate: formatDateOnly(purchaseHeader.purchaseDate),
    warehouseId: purchaseHeader.warehouseId,
    warehouseCode: purchaseHeader.warehouseCode,
    currencyCode: purchaseHeader.currencyCode,
    paymentType: purchaseHeader.paymentType === 5 ? 4 : purchaseHeader.paymentType,
    description: purchaseHeader.description,
    financialAccountId: purchaseHeader.financialAccountId,
    paidAmount: (purchaseHeader.paymentType !== 4 && purchaseHeader.paymentType !== 5) ? totals.netTotal : 0,
    dueDate: purchaseHeader.paymentType === 5 ? formatDateOnly(purchaseHeader.dueDate) : null,
    lines: lines.map((l) => ({
      productId: l.productId,
      quantity: l.quantity,
      unit: l.unit,
      unitPrice: l.unitPrice,
      unitPriceIsVatIncluded: !!l.unitPriceIsVatIncluded,
      addToStock: l.addToStock !== false, // default true
      discountRate: l.discountRate ?? 0,
      vatRate: l.vatRate ?? 0,
      batchNo: l.batchNo,
      expirationDate: l.expirationDate ? formatDateOnly(l.expirationDate) : null,
    })),
  });
useEffect(() => {
  const handleKeyDown = (e) => {
    // 🔒 Dialog açıksa F2 çalışmasın (çok önemli!)
    if (createProductModal.visible) return;

    if (e.key === "F2") {
      e.preventDefault();

      // minimum validasyon (opsiyonel ama öneririm)
      if (!lines.length) return;

      handleSave();
    }
  };

  window.addEventListener("keydown", handleKeyDown);
  return () => window.removeEventListener("keydown", handleKeyDown);
}, [lines, createProductModal.visible]);

  // ✅ Kaydet
  const handleSave = async (shouldNavigate = true) => {
    setIsSubmitting(true);
    try {
      const payload = buildDtoPayload();

      let responseData;
      if (editId) {
        responseData = await SupplierService.updatePurchaseTransaction(payload);
      } else {
        responseData = await SupplierService.saveSupplierPurchaseTransaction({ dto: payload });
      }

      if (responseData.success === true) {
        setIsDirty(false);
        toast.current.show({
          severity: "success",
          summary: "Başarılı",
          detail: editId ? "Alış kaydı güncellendi." : "Tedarikçi ürün ekleme işlemi başarılı.",
          life: 3000,
        });
        if (shouldNavigate) {
          setTimeout(() => {
            if (supplier.id > 0) {
              navigate(`/suppliers/detail/${supplier.id}`, {
                state: {
                  from: "purchase-create",
                },
              });
            } else {
              navigate(`/suppliers`);
            }
            setIsSubmitting(false);
          }, 1000);
        } else {
          setIsSubmitting(false);
        }
        return true;
      } else {
        toast.current.show({
          severity: "error",
          summary: "Hata",
          detail: "İşlem gerçekleştirilemedi.",
          life: 3000
        });
        setIsSubmitting(false);
        return false;
      }
    } catch (err) {
      const msg =
        err?.response?.data?.message ||
        err?.response?.data?.Message ||
        err?.message ||
        "Kayıt sırasında hata oluştu.";
      alert(msg);
      setIsSubmitting(false);
      return false;
    }
  };

useEffect(() => {
  WarehouseService.getAll().then(res => {
    if (res.success) {
      const options = res.data.map(w => ({ label: w.name, value: w.id }));
      setWarehouseOptions(options);
      if (options.length > 0 && !editId) {
        setPurchaseHeader(prev => ({ ...prev, warehouseId: options[0].value }));
      }
    }
  });
}, [editId]);

  const filteredAccounts = useMemo(() => {
    if (purchaseHeader.paymentType === 1) return financialAccounts.filter(a => a.accountType === 1);
    if (purchaseHeader.paymentType === 2) return financialAccounts.filter(a => a.accountType === 2);
    if (purchaseHeader.paymentType === 3) return financialAccounts.filter(a => a.accountType === 3);
    return [];
  }, [financialAccounts, purchaseHeader.paymentType]);

  useEffect(() => {
    if (filteredAccounts.length === 1) {
      setPurchaseHeader(prev => ({ ...prev, financialAccountId: filteredAccounts[0].id }));
    } else {
      setPurchaseHeader(prev => ({ ...prev, financialAccountId: null }));
    }
  }, [filteredAccounts]);
 useEffect(() => {
  // UnitTypes
  api.get("/Lookups/unit-types")
    .then(res => {
      const arr = res.data?.data ?? res.data ?? [];
      const list = arr.map(x => ({ label: x.name, value: x.id }));
      setUnitTypes(list);
    })
    .catch(() => {});
}, []);

useEffect(() => {
  // Categories
  api.get("Category/combo-categories")
    .then(res => { 
      const arr = res.data?.data ?? res.data ?? [];
      const list = arr.map(x => ({
        label: x.label ?? x.name ?? x.text,
        value: x.value ?? x.id
      }));
      setProductCategories(list);
      setFilteredProductCategories(list);
    })
    .catch(() => {});
}, []);

const searchProductCategory = useCallback((e) => {
  const filtered = filterItems(productCategories, e.query);
  setFilteredProductCategories(enrichCategories(filtered, e.query));
}, [productCategories]);

  const productNameRef = useRef(null);

  const openCreateProductModal = (name) => {
    setCreateProductModal({
      visible: true,
      productName: name ?? "",
      barcode: "",
      unitTypeId: 1,
      category: null,
      salePrice: null,
      salePriceIsVatIncluded: false,
      taxRate: 0,
      trackExpirationDate: false,
    });
    setModalErrors({});
  };
  const unitInputRef = useRef(null);
  // ✅ Açılınca birim inputuna fokus
  useEffect(() => {
    if (!createProductModal.visible) return;

    const t = setTimeout(() => {
      // PrimeReact InputNumber iç input’a focus verir
      unitInputRef.current?.focus?.();
    }, 0);

    return () => clearTimeout(t);
  }, [createProductModal.visible]);

  const closeCreateProductModal = (shouldRestoreFocus = true) => {
    setCreateProductModal((p) => ({ ...p, visible: false }));
    setModalErrors({});
    if (shouldRestoreFocus) {
      setTimeout(() => inputRef.current?.focus(), 0);
    }
  };

  useEffect(() => {
    if (createProductModal.visible) {
      setTimeout(() => {
        productNameRef.current?.focus();
        productNameRef.current?.select();
      }, 0);
    }
  }, [createProductModal.visible]);

  const handleCreateProductSubmit = async () => {
    if (!validateProductModal()) return;

    // Backend Request DTO
    const dto = {
      name: createProductModal.productName.trim(),
      barcode: createProductModal.barcode?.trim() || null,
      unitTypeId: createProductModal.unitTypeId ?? null,
      categoryId: createProductModal.category?.value ?? null,
      salePrice: Number(createProductModal.salePrice ?? 0),
      salePriceIsVatIncluded: createProductModal.salePriceIsVatIncluded,
      taxRate: Number(createProductModal.taxRate ?? 0),
      trackExpirationDate: !!createProductModal.trackExpirationDate,
    };

    try {
      const responseData = await SupplierService.fastCreateProduct({ fastProduct: dto });

      // Backend'den dönen yeni ürünü hemen seç
      // responseData'nın, selectProduct fonksiyonunun beklediği formatta (id, name, unit, defaultPurchasePrice vb.) dönmesi gerekir.
      // Eksik alanları varsayılanla tamamlayabiliriz.
      // Backend datasını normalize et
      if (responseData.success === true) {
        toast.current.show({
          severity: "success",
          summary: "Ürün Oluşturuldu",
          detail: "Yeni ürün başarıyla oluşturuldu.",
          life: 3000,
        });
        const data = responseData.data || responseData || {}; 
        const unitLabel = unitTypes.find(x => x.value === (data.unitTypeId ?? dto.unitTypeId))?.label || "";
        const newProduct = {
          id: data.id || responseData.id || Date.now(),
          name: data.name || responseData.name || dto.name, 
          unit: unitLabel,
          defaultPurchasePrice: 0,
          vatRate: data.vatRate || responseData.vatRate || 0,
          isVatIncluded: false,
          trackExpirationDate: data.trackExpirationDate || dto.trackExpirationDate || false,
        };

        selectProduct(newProduct); 
        closeCreateProductModal(false);
      }else{
        toast.current.show({
          severity: "error",
          summary: "Hata",
          detail: responseData?.message || "Ürün oluşturulamadı.",
          life:3000
        })
      }
      

    } catch (error) {
      console.error("Hızlı ürün ekleme hatası:", error);

      let msg = "Ürün eklenirken hata oluştu.";

      if (error?.response?.data?.errors) {
        // Validation hatası detayları
        const errorDetails = Object.values(error.response.data.errors).flat().join("\n");
        msg += "\n" + errorDetails;
      } else if (error?.response?.data?.message) {
        msg += " " + error.response.data.message;
      } else if (error?.message) {
        msg += " " + error.message;
      }
        toast.current.show({
          severity: "error",
          summary: "Hata",
          detail: "Ürün eklenirken hata oluştu. ",
          life:3000
        }) 
    }
  };
  const validateProductModal = () => {
    const errs = {}; 
  if (!createProductModal.productName?.trim()) {
    errs.productName = "Ürün adı zorunlu";
  }

  if (createProductModal.salePrice == null || createProductModal.salePrice < 0) {
    errs.salePrice = "Satış fiyatı zorunlu";
  }

    setModalErrors(errs);
    return Object.keys(errs).length === 0;
  };
 

  const handleExitConfirmSave = async () => {
    const success = await handleSave(false);
    if (success) {
      blocker.proceed();
    }
  };
if (!mounted || loading) {
  return (
    <div className="p-2 md:p-3 space-y-4">
      <Skeleton height="4rem" className="rounded-xl" />
      <div className="grid grid-cols-1 md:grid-cols-12 gap-4">
        <div className="md:col-span-2"><Skeleton height="25rem" className="rounded-2xl" /></div>
        <div className="md:col-span-8"><Skeleton height="25rem" className="rounded-2xl" /></div>
        <div className="md:col-span-2"><Skeleton height="25rem" className="rounded-2xl" /></div>
      </div>
    </div>
  );
}
  return (
    <div className="p-2 md:p-3 space-y-4 animate-fade-in bg-[#f8fafc] dark:bg-slate-950 min-h-screen">
<style>{`
  /* Dark mode overrides for Supplier Purchase Create Page */
  .dark .bg-white {
    background-color: #1e293b !important;
    border-color: #334155 !important;
  }

  .dark .border-slate-200,
  .dark .border-slate-100 {
    border-color: #334155 !important;
  }

  .dark .bg-slate-50,
  .dark .bg-slate-100,
  .dark .bg-slate-50\\/50 {
    background-color: #0f172a !important;
    border-color: #334155 !important;
  }

  .dark .p-dialog .p-dialog-header,
  .dark .p-dialog .p-dialog-content,
  .dark .p-dialog .p-dialog-footer {
    background: #1e293b !important;
    color: #cbd5e1 !important;
    border-color: #334155 !important;
  }

  .dark .p-dialog .p-dialog-header .p-dialog-title {
    color: #ffffff !important;
  }

  .dark .p-dialog .p-dialog-header .p-dialog-header-icon {
    color: #cbd5e1 !important;
  }

  .dark .p-dialog .p-dialog-header .p-dialog-header-icon:hover {
    background: #334155 !important;
    color: #ffffff !important;
  }

  .dark .p-datatable .p-datatable-thead > tr > th {
    background: #0f172a !important;
    color: #94a3b8 !important;
    border-color: #334155 !important;
  }

  .dark .p-datatable .p-datatable-tbody > tr {
    background: #1e293b !important;
    color: #cbd5e1 !important;
    border-color: #334155 !important;
  }

  .dark .p-datatable .p-datatable-tbody > tr:hover {
    background: #334155 !important;
  }

  .dark .p-datatable .p-datatable-emptymessage td {
    background: #1e293b !important;
    border-color: #334155 !important;
  }

  .dark .p-autocomplete-panel {
    background: #1e293b !important;
    color: #cbd5e1 !important;
    border-color: #334155 !important;
  }

  .dark .p-autocomplete-panel .p-autocomplete-items .p-autocomplete-item {
    color: #cbd5e1 !important;
  }

  .dark .p-autocomplete-panel .p-autocomplete-items .p-autocomplete-item:hover {
    background: #334155 !important;
    color: #ffffff !important;
  }
`}</style>
      {mounted && <Toast ref={toast} appendTo={mounted ? document.body : "self"} />}

      {mounted && (
  <Dialog
    header="Kaydedilmemiş Değişiklikler"
    visible={blocker.state === "blocked"}
    style={{ width: '450px' }}
    modal
    appendTo={document.body}
    onHide={() => blocker.reset()}
    footer={
      <div className="flex justify-end gap-2">
        <Button label="İptal" icon="pi pi-times" onClick={() => blocker.reset()} className="p-button-text p-button-secondary" />
        <Button label="Hayır" icon="pi pi-trash" onClick={() => blocker.proceed()} className="p-button-text p-button-danger" />
        <Button label="Evet" icon="pi pi-check" onClick={handleExitConfirmSave} autoFocus className="!bg-blue-600 border-none" />
      </div>
    }
  >
    <div className="flex align-items-center gap-3">
      <i className="pi pi-exclamation-triangle text-warning-500" style={{ fontSize: '2rem' }}></i>
      <span>Değişiklikleriniz kaydedilsin mi?</span>
    </div>
  </Dialog>
)}
      <div className="bg-white shadow-lg shadow-slate-200/50 border border-slate-200 rounded-2xl p-4 md:p-5">
        {/* Top bar */}
        <div className="flex flex-col md:flex-row items-center justify-between mb-6 gap-6">
          {/* Sol: başlık */}
          <div className="space-y-1">
            <div className="flex items-center gap-3">
              <div className="!bg-blue-600 p-3 rounded-xl shadow-md shadow-blue-500/20">
                <i className={`pi ${editId ? 'pi-pencil' : 'pi-cart-arrow-down'} text-white text-xl`}></i>
              </div>
              <div>
                <h1 className="text-xl md:text-2xl font-black text-slate-900 dark:text-white uppercase tracking-tight">{editId ? 'Alış Kaydını Düzenle' : 'Tedarikçiden Ürün Al'}</h1>
                <div className="flex items-center gap-2 mt-0.5">
                   <span className="px-2 py-0.5 bg-blue-50 dark:bg-blue-950/30 text-blue-600 dark:text-blue-400 text-[9px] font-black rounded-lg uppercase border border-blue-100 dark:border-blue-900/30">{editId ? 'DÜZENLEME' : 'YENİ ALIŞ'}</span>
                   <span className="text-slate-400 text-xs font-medium">• Stok giriş ve fatura kaydı</span>
                </div>
              </div>
            </div>
          </div>

          {/* Sağ: tedarikçi chip + aksiyonlar */}
          <div className="flex flex-wrap items-center justify-center md:justify-end gap-4">
            <div className="flex items-center gap-4 px-4 py-3 bg-slate-50 border border-slate-100 rounded-2xl shadow-inner">
              <div className="flex flex-col">
                <span className="text-[9px] text-slate-400 font-black uppercase tracking-widest mb-0.5">Tedarikçi Firma</span>
                <span className="font-black text-slate-800 dark:text-slate-200 tracking-tight leading-none text-sm">{supplier.name}</span>
              </div>
              <div className="w-px h-6 bg-slate-200 dark:bg-slate-700"></div>
              <div className="flex flex-col">
                <span className="text-[9px] text-slate-400 font-black uppercase tracking-widest mb-0.5">Cari Bakiye</span>
                <div className="flex items-center gap-2 leading-none">
                  <span className={`font-black text-base ${supplier.balance >= 0 ? 'text-red-600 dark:text-red-400' : 'text-emerald-600 dark:text-emerald-400'}`}>
                    {supplier.balance.toLocaleString("tr-TR")} ₺
                  </span>
                </div>
              </div>
            </div>
            <Button
              label="KAYDET (F2)"
              tooltip="F2"
              tooltipOptions={{ position: "top" }}
              icon="pi pi-save"
              className="!bg-blue-600 border-none hover:!bg-blue-700 rounded-xl px-8 py-3.5 font-black text-sm shadow-lg !shadow-blue-600/20 transition-all hover:scale-[1.02]"
              onClick={handleSave}
              disabled={lines.length === 0}
            />
          </div>
        </div>

        {/* GRID */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 items-start">
          {/* SOL: EVRAK BİLGİLERİ KARTI */}
          <div className="lg:col-span-2 xl:col-span-2">
            <div className="bg-slate-50/50 border border-slate-200 rounded-2xl p-4 space-y-4">
              <h2 className="text-[10px] font-black text-slate-500 dark:text-slate-400 uppercase tracking-[0.2em] flex items-center gap-2 mb-2">
                <i className="pi pi-file-edit text-blue-600"></i> Evrak Bilgileri
              </h2>

              <div className="space-y-3.5">
                <div className="space-y-1">
                  <label className="text-[9px] text-slate-400 font-black uppercase tracking-wider block ml-1">Fatura / Evrak No</label>
                  <InputText
                    value={purchaseHeader.invoiceNo}
                    onChange={(e) => handleHeaderChange("invoiceNo", e.target.value)}
                    className="w-full border-slate-200 rounded-xl focus:border-blue-500 py-2.5 shadow-sm font-bold text-sm"
                  />
                </div>

                <div className="space-y-1.5">
                  <label className="text-[10px] text-slate-400 font-black uppercase tracking-wider block ml-1">Alış Tarihi</label>
                 {mounted && (
  <Calendar
    value={purchaseHeader.purchaseDate}
    onChange={(e) => handleHeaderChange("purchaseDate", e.value || null)}
    showIcon
    showOnFocus={false}
    appendTo={document.body}
    baseZIndex={10000}
    dateFormat="dd.mm.yy"
    locale="tr"
    className="w-full"
    inputClassName="rounded-2xl border-slate-200 py-3 font-bold"
  />
)} 
                </div>

                <div className="space-y-1.5">
                  <label className="text-[10px] text-slate-400 font-black uppercase tracking-wider block ml-1">Depo Seçimi</label>
                  <Dropdown
                    value={purchaseHeader.warehouseId}
                    onChange={(e) => {
                      const selected = warehouseOptions.find(o => o.value === e.value);
                      setPurchaseHeader(prev => ({
                        ...prev,
                        warehouseId: e.value,
                        warehouseCode: selected ? selected.label : ""
                      }));
                    }}
                    options={warehouseOptions}
                    placeholder="Depo Seçiniz"
                    className="w-full rounded-2xl border-slate-200 py-0.5 shadow-sm font-bold"
                  />
                </div>

                <div className="space-y-1.5">
                  <label className="text-[10px] text-slate-400 font-black uppercase tracking-wider block ml-1">Ödeme Tipi</label>
                  <Dropdown
                    value={purchaseHeader.paymentType}
                    onChange={(e) => handleHeaderChange("paymentType", e.value ?? 4)}
                    options={paymentTypeOptions}
                    className="w-full rounded-2xl border-slate-200 py-0.5 shadow-sm font-bold"
                  />
                </div>

                {purchaseHeader.paymentType === 5 && (
                  <div className="space-y-1.5 animate-fade-in">
                    <label className="text-[10px] text-slate-400 font-black uppercase tracking-wider block ml-1">Vade Tarihi</label>
                    {mounted && (
                      <Calendar
                        value={purchaseHeader.dueDate}
                        onChange={(e) => handleHeaderChange("dueDate", e.value || null)}
                        showIcon
                        showOnFocus={false}
                        appendTo={document.body}
                        baseZIndex={10000}
                        dateFormat="dd.mm.yy"
                        locale="tr"
                        className="w-full"
                        inputClassName="rounded-2xl border-slate-200 py-3 font-bold"
                      />
                    )}
                  </div>
                )}

                {filteredAccounts.length > 0 && (
                   <div className="space-y-1.5">
                    <label className="text-[10px] text-slate-400 font-black uppercase tracking-wider block ml-1">Ödeme Hesabı</label>
                    <Dropdown
                      value={purchaseHeader.financialAccountId}
                      onChange={(e) => handleHeaderChange("financialAccountId", e.value)}
                      options={filteredAccounts}
                      optionLabel="name"
                      optionValue="id"
                      placeholder="Hesap Seçiniz"
                      className="w-full rounded-2xl border-slate-200 py-0.5 shadow-sm font-bold"
                    />
                  </div>
                )}

                <div className="space-y-1.5">
                  <label className="text-[10px] text-slate-400 font-black uppercase tracking-wider block ml-1">İşlem Açıklaması</label>
                  <InputText
                    value={purchaseHeader.description}
                    onChange={(e) => handleHeaderChange("description", e.target.value)}
                    placeholder="Opsiyonel notlar..."
                    className="w-full border-slate-200 rounded-2xl focus:border-blue-500 py-3 shadow-sm font-bold"
                  />
                </div>
              </div>
            </div>
          </div>
          {mounted && <ConfirmPopup appendTo={document.body} />}

          {/* ORTA: ÜRÜN GİRİŞİ + ALIŞ SATIRLARI */}
          <div className="lg:col-span-8 xl:col-span-8">
            <div className="bg-white border border-slate-200 rounded-2xl p-2 md:p-2 space-y-6 relative shadow-sm">
              <div className="flex items-center justify-between">
                <h2 className="text-[10px] font-black text-slate-500 uppercase tracking-[0.2em] flex items-center gap-2">
                  <i className="pi pi-box text-blue-600"></i> Ürün ve Fiyat Girişi
                </h2>
              </div>
              {/* Yeni satır girişi */}
              <div className="flex flex-col gap-4 pb-2">
                {/* Ürün seçimi */}
                <div className="flex flex-col gap-1.5" style={{ position: "relative", zIndex: 10 }}>
                  <label className="text-[9px] text-slate-400 font-black uppercase tracking-wider block ml-1">Ürün Arama (En az 3 karakter)</label>
                  <div className="relative">
                    <i className="pi pi-search absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 z-10 text-sm"></i>
                    <InputText
                      ref={inputRef}
                      value={productQuery}
                      placeholder="Ürün adı veya barkod yazınız..."
                      className="w-full !pl-10 !py-3 border-slate-200 rounded-xl focus:ring-2 focus:ring-blue-500 shadow-sm font-black text-base"
                      onChange={(e) => {
                        const value = e.target.value;
                        setProductQuery(value);
                        if (value.length >= 3) {
                          searchProducts(value);
                        } else {
                          setProducts([]);
                          setShowList(false);
                        }
                      }}
                      onFocus={() => {
                        if (productQuery.length >= 1 && products.length) setShowList(true);
                      }}
                      onKeyDown={(e) => {
                        if (!["ArrowDown", "ArrowUp", "Enter", "Escape"].includes(e.key)) return;
                        if (!products.length) return;
                        if (e.key === "ArrowDown") {
                          setHighlightIndex((prev) => Math.min(prev + 1, products.length - 1));
                        }
                        if (e.key === "ArrowUp") {
                          setHighlightIndex((prev) => Math.max(prev - 1, 0));
                        }
                        if (e.key === "Enter") {
                          if (!showList || !products.length) return;
                          e.preventDefault();
                          const item = products[highlightIndex];
                          if (!item) return;
                          if (item.isCreate) { openCreateProductModal(item.rawName); return; }
                          selectProduct(item);
                        }
                        if (e.key === "Escape") {
                          e.preventDefault();
                          setProductQuery("");
                          setProducts([]);
                          setHighlightIndex(0);
                          setShowList(false);
                          setTimeout(() => { inputRef.current?.focus(); }, 0);
                        }
                      }}
                    />
                  </div>

                  {showList && products.length > 0 && (
                    <div
                      style={{ zIndex: 9999 }}
                      className="absolute top-[100%] left-0 right-0 mt-2 bg-white dark:bg-slate-800 shadow-2xl rounded-2xl border border-slate-100 dark:border-slate-700 max-h-[320px] overflow-y-auto overflow-x-hidden animate-in fade-in slide-in-from-top-2 duration-200"
                    >
                      {products.map((p, i) => (
                        <div
                          key={p.id}
                          onMouseDown={() => {
                            if (p.isCreate) openCreateProductModal(productQuery);
                            else selectProduct(p);
                          }}
                          className={`flex items-center gap-3 px-5 py-4 cursor-pointer transition-all ${
                            i === highlightIndex ? "!bg-blue-600 text-white shadow-lg shadow-blue-600/20 translate-x-2" : "hover:bg-slate-50 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-200"
                          }`}
                        >
                          <i className={`pi ${p.isCreate ? 'pi-plus-circle' : 'pi-box'} ${i === highlightIndex ? '!text-white' : '!text-blue-500'}`}></i>
                          <div className="flex flex-col">
                            <span className="font-black text-sm">{p.name}</span>
                            {!p.isCreate && <span className={`text-[10px] ${i === highlightIndex ? '!text-blue-100' : 'text-slate-400 dark:text-slate-500'}`}>Fiyat: {p.defaultPurchasePrice?.toLocaleString()} ₺ • KDV: %{p.vatRate}</span>}
                          </div>
                        </div>
                      ))}
                    </div>
                  )} 
                </div>

                {/* Alt grid: miktar, fiyat, iskonto, kdv */}
                <div className="grid grid-cols-2 md:grid-cols-5 gap-3 mt-1 bg-slate-50/50 p-3 rounded-xl border border-slate-100">
                  <div className="space-y-1">
                    <label className="text-[9px] text-slate-400 font-black uppercase tracking-wider block ml-1">Miktar</label>
                    <InputNumber
                      ref={quantityRef}
                      value={newLine.quantity}
                      onValueChange={(e) => handleNewLineChange("quantity", e.value || 0)}
                      min={1}
                      className="w-full"
                      inputClassName="w-full rounded-lg border-slate-200 py-2 font-black text-center text-base"
                      onKeyDown={(e) => {
                        if (e.key === "Enter") { e.preventDefault(); focusAndSelect(priceRef); }
                      }}
                    />
                  </div>

                  <div className="space-y-1 ">
                    <label className="text-[10px] text-slate-400 font-black uppercase tracking-wider block ml-1">Birim Fiyat</label>
                    <InputNumber
                      minFractionDigits={2}
                      maxFractionDigits={6}
                      ref={priceRef}
                      value={newLine.unitPrice}
                      onValueChange={(e) => handleNewLineChange("unitPrice", e.value || 0)}
                      mode="currency"
                      currency="TRY"
                      locale="tr-TR"
                      className="w-full"
                      inputClassName="w-full rounded-xl border-slate-200 py-2 font-black text-center text-base"
                      onKeyDown={(e) => {
                        if (e.key === "Enter") { e.preventDefault(); focusAndSelect(totalPriceRef); }
                      }}
                    />
                  </div>

                  <div className="space-y-1 ">
                    <label className="text-[10px] text-slate-400 font-black uppercase tracking-wider block ml-1">Toplam Fiyat</label>
                    <InputNumber
                      ref={totalPriceRef}
                      value={(newLine.quantity || 0) * (newLine.unitPrice || 0)}
                      onValueChange={(e) => {
                        const total = e.value || 0;
                        const qty = newLine.quantity || 1;
                         if (!qty || qty <= 0) {
                              handleNewLineChange("unitPrice", 0);
                              return;
                            }

                            const calculatedUnitPrice = total / qty;

                            if (!Number.isFinite(calculatedUnitPrice)) {
                              handleNewLineChange("unitPrice", 0);
                              return;
                            }

                            handleNewLineChange("unitPrice", calculatedUnitPrice);
                      }}
                      minFractionDigits={2}
                      maxFractionDigits={4}
                      mode="currency"
                      currency="TRY"
                      locale="tr-TR"
                      className="w-full"
                      inputClassName="w-full rounded-xl border-slate-200 py-2 font-black text-center text-base text-emerald-600 dark:text-emerald-400"
                      onKeyDown={(e) => {
                        if (e.key === "Enter") { e.preventDefault(); focusAndSelect(discountRef); }
                      }}
                    />
                  </div>

                  <div className="space-y-1 ">
                    <label className="text-[10px] text-slate-400 font-black uppercase tracking-wider block ml-1">İskonto (%)</label>
                    <InputNumber
                      ref={discountRef}
                      value={newLine.discountRate}
                      onValueChange={(e) => handleNewLineChange("discountRate", e.value || 0)}
                      suffix="%"
                      min={0}
                      max={100}
                      className="w-full"
                      inputClassName="w-full rounded-xl border-slate-200 py-2 font-black text-center text-base text-red-600 dark:text-red-400"
                      onKeyDown={(e) => {
                        if (e.key === "Enter") { e.preventDefault(); focusAndSelect(vatRef); }
                      }}
                    />
                  </div>

                  <div className="space-y-1 ">
                    <label className="text-[10px] text-slate-400 font-black uppercase tracking-wider block ml-1">KDV (%)</label>
                    <InputNumber
                      ref={vatRef}
                      value={newLine.vatRate}
                      onValueChange={(e) => handleNewLineChange("vatRate", e.value || 0)}
                      suffix="%"
                      min={0}
                      max={100}
                      className="w-full"
                      inputClassName="w-full rounded-xl border-slate-200 py-2 font-black text-center text-base text-blue-600 dark:text-blue-400" 
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          if (newLine.product?.trackExpirationDate || newLine.product?.TrackExpirationDate) {
                            focusAndSelect(batchNoRef);
                          } else {
                            document.getElementById("addLineBtn")?.focus();
                          }
                        }
                      }} 
                    />
                  </div>

                  {(newLine.product?.trackExpirationDate || newLine.product?.TrackExpirationDate) && (
                    <>
                      <div className="space-y-1 animate-fade-in">
                        <label className="text-[10px] text-slate-400 font-black uppercase tracking-wider block ml-1">Parti No</label>
                        <InputText
                          ref={batchNoRef}
                          value={newLine.batchNo}
                          onChange={(e) => handleNewLineChange("batchNo", e.target.value)}
                          className="w-full rounded-xl border-slate-200 py-2 font-black text-center text-base"
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              expirationDateRef.current?.focus();
                            }
                          }}
                        />
                      </div>
                      <div className="space-y-1 animate-fade-in">
                        <label className="text-[10px] text-slate-400 font-black uppercase tracking-wider block ml-1">SKT</label>
                        <Calendar
                          ref={expirationDateRef}
                          value={newLine.expirationDate}
                          onChange={(e) => handleNewLineChange("expirationDate", e.value)}
                          dateFormat="dd.mm.yy"
                          locale="tr"
                          className="w-full"
                          inputClassName="w-full rounded-xl border-slate-200 py-2 font-black text-center text-base"
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              document.getElementById("addLineBtn")?.focus();
                            }
                          }}
                        />
                      </div>
                    </>
                  )}

                  {/* 🔔 KDV dahil/hariç ve Stoğa Ekle checkboxları */}
                  <div className="col-span-2 md:col-span-3 mt-1 flex items-center gap-6 bg-white px-4 py-2 rounded-xl border border-slate-100 shadow-sm w-fit">
                    <div className="flex items-center gap-2">
                      <Checkbox
                        checked={!!newLine.unitPriceIsVatIncluded}
                        onChange={(e) => handleNewLineChange("unitPriceIsVatIncluded", e.checked)}
                        inputId="vatIncludedCheck"
                      />
                      <label htmlFor="vatIncludedCheck" className="text-xs font-black text-slate-500 dark:text-slate-300 uppercase tracking-tighter cursor-pointer select-none">Birim fiyat KDV dahil</label>
                    </div>

                    <div className="flex items-center gap-2">
                      <Checkbox
                        checked={!!newLine.addToStock}
                        onChange={(e) => handleNewLineChange("addToStock", e.checked)}
                        inputId="addToStockCheck"
                      />
                      <label htmlFor="addToStockCheck" className="text-xs font-black text-blue-600 dark:text-blue-400 uppercase tracking-tighter cursor-pointer select-none">Stoğa Ekle</label>
                    </div>
                  </div>

                  <div className="col-span-2 md:col-span-1 flex items-center justify-end">
                    <Button
                    id="addLineBtn"
                      label={isAddFocused ? "ENTER ile EKLE" : "EKLE"}
                      icon="pi pi-plus"
                      className={`add-line-btn ${isAddFocused ? "is-focused" : ""} bg-emerald-500 border-none hover:bg-emerald-600 rounded-xl px-6 py-4 font-black text-white shadow-lg shadow-emerald-500/20 w-full transition-all active:scale-95`}
                      onFocus={() => setIsAddFocused(true)}
                      onBlur={() => setIsAddFocused(false)}
                      onClick={() => handleAddLine()}
                      disabled={!newLine.product || !newLine.unitPrice || newLine.quantity <= 0}
                    />
                  </div>
                </div>
              </div>

              <div className="h-px bg-slate-100 my-4"></div>

              {/* Satır tablosu */}
              <div className="space-y-4">
                <h3 className="text-[11px] font-black text-slate-400 uppercase tracking-[0.2em] flex items-center gap-2">
                  <i className="pi pi-list text-blue-500"></i> Alış Satırları
                </h3>

                <DataTable
                  value={lines}
                  size="small"
                  responsiveLayout="scroll"
                  className="p-datatable-sm"
                  editMode="row"
                  dataKey="id"
                  onRowEditInit={onRowEditInit}
                  onRowEditSave={onRowEditSave}
                  onRowEditCancel={onRowEditCancel}
                  rowClassName={() => 'hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors'}
                  emptyMessage={
                    <div className="flex flex-col items-center gap-2 py-6 text-slate-400">
                      <i className="pi pi-inbox text-3xl"></i>
                      <span className="font-bold text-sm">
                        Henüz ürün eklenmedi
                      </span>
                      <span className="text-xs">
                        Yukarıdan ürün seçerek satır ekleyebilirsin
                      </span>
                    </div>
                  }
                >
                  <Column
                    field="productName"
                    header="Ürün"
                    headerClassName="bg-slate-50 dark:bg-slate-800 text-slate-500 dark:text-slate-400 font-black text-[10px] uppercase py-3 px-4"
                    className="py-3 px-4 font-bold text-slate-700 dark:text-slate-300"
                    style={{ minWidth: "180px" }}
                  />
                  <Column
                    field="quantity"
                    header="Miktar"
                    headerClassName="bg-slate-50 dark:bg-slate-800 text-slate-500 dark:text-slate-400 font-black text-[10px] uppercase py-3 px-4"
                    editor={(options) => (
                      <InputNumber
                        value={options.value}
                        onValueChange={(e) => options.editorCallback(e.value)}
                        min={1}
                        className="w-full"
                        inputClassName="rounded-lg border-slate-200 dark:border-slate-600 dark:bg-slate-900 dark:text-white"
                      />
                    )}
                    body={(rowData) => (
                      <span className="font-medium text-slate-600 dark:text-slate-300">
                        {rowData.quantity} {rowData.unit || ""}
                      </span>
                    )}
                    style={{ width: "110px" }}
                  />
                  <Column
                    field="unitPrice"
                    header="Birim Fiyat"
                    headerClassName="bg-slate-50 dark:bg-slate-800 text-slate-500 dark:text-slate-400 font-black text-[10px] uppercase py-3 px-4"
                    editor={(options) => (
                      <InputNumber
                        value={options.value}
                        onValueChange={(e) => options.editorCallback(e.value)}
                        minFractionDigits={2}
                        maxFractionDigits={6}
                        mode="currency"
                        currency="TRY"
                        locale="tr-TR"
                        className="w-full"
                        inputClassName="rounded-lg border-slate-200 dark:border-slate-600 dark:bg-slate-900 dark:text-white"
                      />
                    )}
                    body={(rowData) => (
                      <span className="text-slate-600 dark:text-slate-300">
                         {rowData.unitPrice?.toLocaleString("tr-TR", {
                            minimumFractionDigits: 4,
                            maximumFractionDigits: 4,
                          })} ₺
                      </span>
                    )}
                    style={{ width: "120px" }}
                  />
                  <Column
                    field="discountRate"
                    header="İsk"
                    headerClassName="bg-slate-50 dark:bg-slate-800 text-slate-500 dark:text-slate-400 font-black text-[10px] uppercase py-3 px-4"
                    editor={(options) => (
                      <InputNumber
                        value={options.value}
                        onValueChange={(e) => options.editorCallback(e.value)}
                        suffix="%"
                        min={0}
                        max={100}
                        className="w-full"
                        inputClassName="rounded-lg border-slate-200 dark:border-slate-600 dark:bg-slate-900 dark:text-white"
                      />
                    )}
                    body={(rowData) => rowData.discountRate > 0 ? <span className="text-red-500 dark:text-red-400 font-bold">%{rowData.discountRate}</span> : '-'}
                    style={{ width: "80px" }}
                  />
                  <Column
                    field="addToStock"
                    header="Stok"
                    headerClassName="bg-slate-50 dark:bg-slate-800 text-slate-500 dark:text-slate-400 font-black text-[10px] uppercase py-3 px-4 text-center"
                    className="text-center"
                    editor={(options) => (
                      <Checkbox
                        checked={options.value}
                        onChange={(e) => options.editorCallback(e.checked)}
                      />
                    )}
                    body={(rowData) => (
                      <i className={`pi ${rowData.addToStock !== false ? 'pi-check-circle text-emerald-500' : 'pi-times-circle text-red-400'} text-lg`}></i>
                    )}
                    style={{ width: "70px" }}
                  />
                  <Column
                    field="batchNo"
                    header="Parti No / SKT"
                    headerClassName="bg-slate-50 dark:bg-slate-800 text-slate-500 dark:text-slate-400 font-black text-[10px] uppercase py-3 px-4"
                    body={(rowData) => (
                      <div className="flex flex-col text-[11px]">
                        <span className="font-bold text-slate-700 dark:text-slate-300">{rowData.batchNo || '-'}</span>
                        <span className="text-slate-400 dark:text-slate-500">
                          {rowData.expirationDate ? new Date(rowData.expirationDate).toLocaleDateString('tr-TR') : '-'}
                        </span>
                      </div>
                    )}
                    style={{ width: "100px" }}
                  />
                  <Column
                    field="vatRate"
                    header="KDV"
                    headerClassName="bg-slate-50 dark:bg-slate-800 text-slate-500 dark:text-slate-400 font-black text-[10px] uppercase py-3 px-4"
                    editor={(options) => (
                      <InputNumber
                        value={options.value}
                        onValueChange={(e) => options.editorCallback(e.value)}
                        suffix="%"
                        min={0}
                        max={100}
                        className="w-full"
                        inputClassName="rounded-lg border-slate-200 dark:border-slate-600 dark:bg-slate-900 dark:text-white"
                      />
                    )}
                    body={(rowData) => <span className="text-blue-500 dark:text-blue-400 font-bold">%{rowData.vatRate}</span>}
                    style={{ width: "80px" }}
                  />
                  <Column
                    header="Toplam"
                    headerClassName="bg-slate-50 dark:bg-slate-800 text-slate-500 dark:text-slate-400 font-black text-[10px] uppercase py-3 px-4"
                    body={lineTotalTemplate}
                    style={{ width: "120px", textAlign: "right" }}
                    className="font-black text-slate-800 dark:text-slate-200"
                  />
                  <Column
                    headerClassName="bg-slate-50 dark:bg-slate-800"
                    bodyStyle={{ textAlign: "right" }}
                    body={(rowData) => (
                      <div className="flex items-center justify-end gap-1">
                        <Button
                          icon="pi pi-minus"
                          className="w-8 h-8 p-0 border-none bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300 hover:bg-slate-200 dark:hover:bg-slate-700 rounded-lg transition-colors"
                          onClick={() => changeLineQuantity(rowData.id, -1)}
                          disabled={(rowData.quantity || 0) <= 1}
                        />
                        <Button
                          icon="pi pi-plus"
                          className="w-8 h-8 p-0 border-none bg-blue-50 dark:bg-blue-950/40 text-blue-600 dark:text-blue-400 hover:bg-blue-100 dark:hover:bg-blue-900/30 rounded-lg transition-colors"
                          onClick={() => changeLineQuantity(rowData.id, 1)}
                        />
                      </div>
                    )}
                  />
                  <Column rowEditor headerClassName="bg-slate-50 dark:bg-slate-800" bodyStyle={{ textAlign: "right" }} />
                  <Column
                    headerClassName="bg-slate-50 dark:bg-slate-800"
                    bodyStyle={{ textAlign: "right" }}
                    body={(rowData) => (
                      <Button
                        icon="pi pi-trash"
                        className="w-8 h-8 p-0 border-none bg-red-50 dark:bg-red-950/40 text-red-600 dark:text-red-400 hover:bg-red-100 dark:hover:bg-red-900/30 rounded-lg transition-colors"
                        onClick={(e) => openDeleteConfirm(e, rowData.id)}
                      />
                    )}
                  />
                </DataTable>
              </div>
            </div>
          </div>

          {/* SAĞ: ÖZET BİLGİ KARTI */}
          <div className="lg:col-span-2 xl:col-span-2 h-full">
            <div className="bg-slate-900 text-slate-50 rounded-2xl p-3 space-y-6 h-full shadow-xl shadow-slate-900/30 relative overflow-hidden flex flex-col justify-between">
              <div className="absolute top-0 right-0 w-32 h-32 bg-blue-500/10 rounded-full -mr-16 -mt-16 blur-2xl"></div>

              <div className="space-y-3 relative z-10">
                <h2 className="text-[14px] font-black text-blue-400 uppercase tracking-[0.1em] flex items-center gap-2">
                  <div className="w-1.5 h-1.5 rounded-full bg-blue-500 animate-pulse"></div>
                  Fatura ÖZETİ
                </h2>

                <div className="space-y-2 relative z-10">
  <div className="text-xs opacity-60 mt-4">
    <span className="font-bold uppercase tracking-tighter block mb-0.5">
      Ara Toplam
    </span>
    <span className="font-black text-white block break-words leading-tight">
      {totals.gross.toLocaleString('tr-TR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })} ₺
    </span>
  </div>

  <div className="text-xs text-red-400 mt-4 font-bold">
    <span className="uppercase tracking-tighter block mb-0.5">
      Toplam İskonto
    </span>
    <span className="font-black block break-words leading-tight">
      -{totals.discountTotal.toLocaleString('tr-TR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })} ₺
    </span>
  </div>

  <div className="text-xs text-blue-400 mt-4 font-bold">
    <span className="uppercase tracking-tighter block mb-0.5">
      Toplam KDV
    </span>
    <span className="font-black block break-words leading-tight">
      +{totals.vatTotal.toLocaleString('tr-TR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })} ₺
    </span>
  </div>

  <div className="pt-4 border-t border-slate-800 mt-2 space-y-3">
    <div className="flex justify-between items-center opacity-60 text-xs">
        <span className="font-bold uppercase tracking-tighter">Genel Toplam</span>
        <span className="font-black">{totals.netTotal.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺</span>
    </div>
    {totals.paidTotal > 0 && (
        <div className="flex justify-between items-center text-xs text-emerald-400">
            <span className="font-bold uppercase tracking-tighter">Yapılan Ödemeler</span>
            <span className="font-black">-{totals.paidTotal.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺</span>
        </div>
    )}
    <div className="space-y-1">
        <span className="text-[9px] font-black text-slate-500 uppercase tracking-[0.2em] block">
            {totals.paidTotal > 0 ? 'KALAN ÖDENECEK TUTAR' : 'ÖDENECEK TOPLAM TUTAR'}
        </span>
        <div className="text-xl font-black text-white tracking-tight break-words leading-tight">
            {totals.remainingTotal.toLocaleString('tr-TR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })}{' '}
            <span className="text-lg text-blue-500 ml-0.5">₺</span>
        </div>
    </div>
  </div>
</div>
              </div>

              <div className="space-y-3 relative z-10">
                 <div className="grid grid-cols-2 gap-3">
                  <div className="bg-white/5 backdrop-blur-md p-3 rounded-xl border border-white/10 text-center group hover:bg-white/10 transition-colors">
                    <span className="text-[9px] block text-slate-500 mb-0.5 uppercase font-black tracking-widest">KALEM</span>
                    <span className="font-black text-lg text-white">{totals.lineCount}</span>
                  </div>
                  <div className="bg-white/5 backdrop-blur-md p-3 rounded-xl border border-white/10 text-center group hover:bg-white/10 transition-colors">
                    <span className="text-[9px] block text-slate-500 mb-0.5 uppercase font-black tracking-widest">ADET</span>
                    <span className="font-black text-lg text-white">{totals.totalQuantity}</span>
                  </div>
                </div>

                {purchaseHeader.existingPayments?.length > 0 && (
                    <div className="space-y-2">
                        <span className="text-[9px] font-black text-slate-500 uppercase tracking-widest block ml-1">Yapılan Ödemeler</span>
                        <div className="space-y-1.5 max-h-[150px] overflow-y-auto custom-scrollbar pr-1">
                            {purchaseHeader.existingPayments.map(p => (
                                <div key={p.id} className="flex justify-between items-center bg-white/5 p-2 rounded-lg border border-white/10 text-[10px]">
                                    <div className="flex flex-col">
                                        <span className="text-slate-400">{p.date}</span>
                                        <span className="font-bold text-emerald-400">{p.paymentMethod || 'Ödeme'}</span>
                                    </div>
                                    <span className="font-black">₺{Math.abs(p.amount).toLocaleString()}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                <div className="bg-blue-600/10 p-3 rounded-xl border border-blue-500/20 text-[9px] text-blue-400 font-bold italic leading-relaxed text-center">
                  Genel toplam, KDV ve iskontolar dahil edilmiş net tutardır.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Dialog
        header={
          <div className="flex flex-col gap-1">
            <div className="text-xl font-black text-slate-800 dark:text-white tracking-tight uppercase">🆕 Hızlı Ürün Ekle</div>
            <div className="text-xs text-slate-400 font-bold uppercase tracking-wider">
              Ürünü tanımla, alış ekranına geri dön.
            </div>
          </div>
        }
        visible={createProductModal.visible}
        onHide={closeCreateProductModal}
        modal
        closable
        closeOnEscape
        draggable={false}
        resizable={false}
        baseZIndex={11000}
        appendTo={mounted ? document.body : undefined}
        breakpoints={{ "960px": "75vw", "641px": "95vw" }}
        style={{ width: "600px" }}
        headerClassName="bg-slate-50 border-b border-slate-100 p-4 md:p-4 rounded-t-3xl"
        contentClassName="max-h-[70vh] overflow-y-auto"
        footerClassName="bg-slate-50 border-t border-slate-100 p-4 rounded-b-3xl"
        footer={
          <div className="flex items-center justify-between w-full gap-3">
            <Button
              label="İPTAL"
              icon="pi pi-times"
              className="p-button-text text-slate-400 font-black"
              onClick={closeCreateProductModal}
            />
            <Button
              ref={saveProductBtnRef}
              label="ÜRÜNÜ KAYDET"
              icon="pi pi-check"
              className="save-product-btn !bg-blue-600 border-none px-6 py-3 font-black rounded-xl shadow-lg shadow-blue-500/20 transition-all hover:scale-[1.02]"
              onClick={handleCreateProductSubmit}
            />
          </div>
        }
      >
        <div className="flex flex-col gap-5">
          {/* Temel Bilgiler Paneli */}
          <div className="bg-white rounded-2xl p-4 border border-slate-200 shadow-sm space-y-4">
            <div className="text-[10px] font-black text-slate-500 uppercase tracking-widest flex items-center gap-2 mb-2">
              <i className="pi pi-info-circle text-blue-500"></i> Temel Ürün Bilgileri
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="flex flex-col gap-1.5">
                <label className="text-[10px] text-slate-400 font-black uppercase tracking-wider ml-1">
                  Ürün Adı <span className="text-red-500">*</span>
                </label>
                <InputText
                  value={createProductModal.productName}
                  placeholder="Örn: Kola Koli 24'lü"
                  onChange={(e) =>
                    setCreateProductModal((p) => ({ ...p, productName: e.target.value }))
                  }
                  className={`w-full rounded-xl border-slate-200 py-3 font-bold ${modalErrors.productName ? "p-invalid border-red-500" : ""}`}
                />
                {modalErrors.productName && <small className="text-red-500 font-bold ml-1">{modalErrors.productName}</small>}
              </div>

              <div className="flex flex-col gap-1.5">
                <label className="text-[10px] text-slate-400 font-black uppercase tracking-wider ml-1">
                  Barkod (Opsiyonel)
                </label>
                <InputText
                  value={createProductModal.barcode}
                  placeholder="Barkod okutun veya yazın"
                  onChange={(e) =>
                    setCreateProductModal((p) => ({ ...p, barcode: e.target.value }))
                  }
                  className="w-full rounded-xl border-slate-200 py-3 font-bold"
                />
              </div>
            </div>
          </div>

          {/* Kategori ve Birim Paneli */}
          <div className="bg-slate-50/50 rounded-2xl p-4 border border-slate-200 shadow-sm space-y-4">
            <div className="text-[10px] font-black text-slate-500 uppercase tracking-widest flex items-center gap-2 mb-2">
               <i className="pi pi-box text-blue-500"></i> Kategori ve Satış Birimi
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="flex flex-col gap-1.5">
                <label className="text-[10px] text-slate-400 font-black uppercase tracking-wider ml-1">
                  Kategori
                </label>
                <AutoComplete
                  inputId="categoryAuto"
                  value={createProductModal.category}
                  suggestions={filteredProductCategories}
                  completeMethod={searchProductCategory}
                  field="label"
                  dropdown
                  appendTo="self"
                  itemTemplate={(item) =>
                    item?.isCreate ? (
                      <div className="flex items-center gap-2 text-blue-600 font-black">
                        <i className="pi pi-plus-circle"></i>{item.label}
                      </div>
                    ) : (
                      <span>{item?.label}</span>
                    )
                  }
                  onChange={async (e) => {
                    const selected = e.value;
                    if (typeof selected === 'object' && selected?.isCreate) {
                      try {
                        const res = await api.post("Category/create", { name: selected.rawName });
                        const newCategory = { label: res.data.data.name, value: res.data.data.id };
                        setProductCategories(prev => [...prev, newCategory]);
                        setCreateProductModal(p => ({ ...p, category: newCategory }));
                        toast.current?.show({ severity: "success", summary: "Kategori eklendi", detail: `"${newCategory.label}"`, life: 2000 });
                      } catch {
                        toast.current?.show({ severity: "error", summary: "Hata", detail: "Kategori eklenemedi", life: 2500 });
                      }
                      return;
                    }
                    setCreateProductModal(p => ({ ...p, category: selected || null }));
                  }}
                  className="w-full"
                  inputClassName="w-full rounded-xl border-slate-200 py-3 font-bold"
                  placeholder="Kategori seç..."
                />
              </div>

              <div className="flex flex-col gap-1.5">
                <label className="text-[10px] text-slate-400 font-black uppercase tracking-wider ml-1">
                  Satış Birimi <span className="text-red-500">*</span>
                </label>
                <Dropdown
                  value={createProductModal.unitTypeId}
                  options={unitTypes}
                  optionLabel="label"
                  optionValue="value"
                  filter
                  appendTo="self"
                  className="w-full rounded-xl border-slate-200 py-0.5"
                  inputId="unitTypeDropdown"
                  onChange={(e) => setCreateProductModal(p => ({ ...p, unitTypeId: e.value ?? null }))}
                />
              </div>
            </div>
          </div>

          {/* Fiyat ve KDV Paneli */}
          <div className="bg-emerald-50/30 dark:bg-emerald-950/20 rounded-2xl p-4 border border-emerald-100 dark:border-emerald-900/30 shadow-sm space-y-4">
            <div className="text-[10px] font-black text-emerald-700 dark:text-emerald-400 uppercase tracking-widest flex items-center gap-2 mb-2">
               <i className="pi pi-tag text-emerald-600 dark:text-emerald-400"></i> Satış Fiyatı ve KDV Ayarları
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="flex flex-col gap-1.5">
                <label className="text-[10px] text-slate-400 font-black uppercase tracking-wider ml-1">
                  Satış Fiyatı <span className="text-red-500">*</span>
                </label>
                <InputNumber
                  value={createProductModal.salePrice}
                  onValueChange={(e) => setCreateProductModal((p) => ({ ...p, salePrice: e.value }))}
                  mode="currency"
                  currency="TRY"
                  locale="tr-TR"
                  inputId="salePriceInput"
                  className="w-full"
                  inputClassName={`w-full rounded-xl border-slate-200 py-3 font-black text-xl text-emerald-600 dark:text-emerald-400 ${modalErrors.salePrice ? "p-invalid border-red-500" : ""}`}
                />
                {modalErrors.salePrice && <small className="text-red-500 font-bold ml-1">{modalErrors.salePrice}</small>}
              </div>

              <div className="grid grid-cols-2 gap-3">
                <div className="flex flex-col gap-1.5">
                  <label className="text-[10px] text-slate-400 font-black uppercase tracking-wider ml-1">KDV (%)</label>
                  <InputNumber
                    value={createProductModal.taxRate}
                    onValueChange={(e) => setCreateProductModal((p) => ({ ...p, taxRate: e.value ?? 0 }))}
                    suffix="%"
                    min={0}
                    max={100}
                    useGrouping={false}
                    className="w-full"
                    inputClassName="w-full rounded-xl border-slate-200 py-3 font-black text-center"
                  />
                </div>
                <div className="flex flex-col gap-1.5">
                  <label className="text-[10px] text-slate-400 font-black uppercase tracking-wider ml-1">KDV Dahil</label>
                  <div className="flex items-center justify-center bg-white dark:bg-slate-800 h-[50px] rounded-xl border border-slate-200 dark:border-slate-700 shadow-sm">
                    <Checkbox
                      inputId="vatIncSale"
                      checked={!!createProductModal.salePriceIsVatIncluded}
                      onChange={(e) => setCreateProductModal((p) => ({ ...p, salePriceIsVatIncluded: !!e.checked }))}
                    />
                  </div>
                </div>
              </div>

              <div className="flex flex-col gap-1.5 mt-2">
                <label className="text-[10px] text-slate-400 font-black uppercase tracking-wider ml-1">SKT Takibi</label>
                <div className="flex items-center gap-2 bg-white dark:bg-slate-800 h-[50px] px-4 rounded-xl border border-slate-200 dark:border-slate-700 shadow-sm">
                  <Checkbox
                    inputId="trackExpFast"
                    checked={!!createProductModal.trackExpirationDate}
                    onChange={(e) => setCreateProductModal((p) => ({ ...p, trackExpirationDate: !!e.checked }))}
                  />
                  <label htmlFor="trackExpFast" className="text-xs font-bold text-slate-600 dark:text-slate-300">Evet, SKT takibi yapılsın</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Dialog>

    </div>
  );
}
